import React, { useCallback } from 'react'
import { useParams } from 'react-router-dom'

import { Layout } from 'admin/lib/Layouts'

import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { useApiQuery } from 'admin/lib/Api'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import * as ROUTES from 'admin/routes'

import { EditReferenceProductItemForm } from './EditReferenceProductItemForm'
import { ShortcutsModalButton } from 'admin/lib/ShortcutsModalButton'

export function EditReferenceProductItem() {
  const { referenceItemId } = useParams()

  const referenceProductItem = useApiQuery(
    useCallback(
      api => {
        if (referenceItemId === 'register') {
          return [{}, null, null]
        }
        return api.getReferenceProductItem(referenceItemId)
      },
      [referenceItemId]
    )
  )

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem href={ROUTES.REFERENCEITEMS.LIST}>
                    Reference Product Items
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: referenceItemId
              }
            ]}
          />

          <ShortcutsModalButton />
        </>
      }
    >
      {!referenceProductItem.loaded && <ScreenSpin />}

      {referenceProductItem.loaded && (
        <EditReferenceProductItemForm
          referenceProductItem={referenceProductItem.data}
          isNew={referenceItemId === 'register'}
        />
      )}
    </Layout>
  )
}
